import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { FeldBefund } from './feldpruefungApi';

const STIL = {
  ok: { farbe: '#1e6b3a', Icon: CheckCircleOutlineIcon },
  hinweis: { farbe: '#1d4f91', Icon: InfoOutlinedIcon },
  warnung: { farbe: '#8a4b00', Icon: WarningAmberIcon },
} as const;

/**
 * Ergebnis der Feldprüfung direkt unter dem Feld. Nur Hinweise — es sperrt nichts. Ein grünes „passt“ zeigen wir
 * nur von der KI (Regeln melden nur Probleme), damit kein Grün neben einem Problem steht.
 */
const Feldhinweis: FC<{ befunde: FeldBefund[]; laeuft?: boolean }> = ({ befunde, laeuft }) => {
  if (!laeuft && befunde.length === 0) return null;
  const sichtbar = befunde.some((b) => b.schwere !== 'ok')
    ? befunde.filter((b) => b.schwere !== 'ok')
    : befunde;
  return (
    <Box sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {laeuft && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <CircularProgress size={12} />
          <Typography variant="caption" color="text.secondary">
            wird geprüft …
          </Typography>
        </Box>
      )}
      {sichtbar.map((b, i) => {
        const s = STIL[b.schwere];
        return (
          <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
            <s.Icon sx={{ fontSize: 15, color: s.farbe, mt: '2px' }} />
            <Typography variant="caption" sx={{ color: s.farbe, lineHeight: 1.4 }}>
              {b.text}
              {/* Nur KI-Befunde tragen eine Herkunft — „Regel“ verstand keine Persona (Runde 3); feste Prüfungen
                  sind sicher, eine KI-Meinung kann irren, und genau das soll man sehen. */}
              {b.quelle === 'ki' && (
                <Box component="span" sx={{ color: 'text.disabled', ml: 0.75 }}>
                  KI-Prüfung (kann irren)
                </Box>
              )}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default Feldhinweis;
